<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid p-0">
        <!-- Unlock page start-->
        <div class="authentication-main mt-0 unlock-card">
          <div class="row">
            <div class="col-12">
              <div class="login-card">
                <div>
                  <div>
                    <a class="logo">
                      <img
                        class="img-fluid for-light"
                        src="../../assets/images/logo/logo.png"
                        alt="looginpage"
                      />
                      <img
                        class="img-fluid for-dark"
                        src="../../assets/images/logo/logo_dark.png"
                        alt="looginpage"
                      />
                    </a>
                  </div>
                  <div class="login-main login-form-card">
                    <b-alert variant="danger" :show="!error_message==''" class="alert alert-warning inverse alert-dismissible">
                          <i class="icon-bell"></i>
                          <p>{{error_message}}</p>
                    </b-alert>
                    <b-alert variant="success" :show="successed" class="alert alert-warning inverse alert-dismissible">
                          <i class="icon-bell"></i>
                          <p>email verification was successfully</p>
                    </b-alert>
                    <form class="theme-form" @submit.prevent="handleSubmit">
                      <h4>Verify Email</h4>
                      <label class="col-form-label">Email Address</label>
                      <input
                        class="form-control"
                        type="email"
                        required=""
                        placeholder=""
                        v-model="email"
                        disabled
                      />
                      <div class="form-group">
                        <label class="col-form-label"
                          >Enter your email verification code</label
                        >
                        <input
                          class="form-control"
                          :type="type"
                          name="login[password]"
                          required=""
                          placeholder="*********"
                          v-model="code"
                        />
                        <div class="show-hide" @click="showPassword"><span class="show"> </span></div>
                      </div>
                      <div class="form-group mb-0">
                        <button class="btn btn-primary btn-block" type="submit">
                          Verify
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Verify page end-->
      </div>
    </div>
  </div>
</template>
<script>

  import { authService } from './../../_services';
  export default {
    name: 'register',
    data() {
      return {
        type:'password',
        email: '',
        code:'',
        submitted:false,
        error_message:'',
        successed:false
      };
    },
    computed: {
      // JWT authentication
      loggingIn() {
        return this.$store.state.authentication.status.loggingIn;
      },
    },
    created() {
      this.email = this.$route.query.email;
    },
    methods: {
      handleSubmit: function() {
        this.submitted = true;
        this.error_message = '';
        var self = this;
        const { email, code } = this;

        authService.verify_email(email,code).then((response) => {
          response.text().then(text => {
            const data = text && JSON.parse(text);
            if (!response.ok) {
              const error = (data && data.message) || response.statusText;
              return Promise.reject(error);
            } else {
              self.successed = true;
              this.$notify({ text: 'email verification is successfully',type: 'success' });
              this.$router.push('/login');
            }
          }).catch( error => {
            self.error_message = error;
          });
        });
      },
      // show/hide password
      showPassword: function() {
        if (this.type === 'password') {
          this.type = 'text';
        } else {
          this.type = 'password';
        }
      },
    },
  };
</script>

